export const CITY_MINIMAL_FIELDS = `
  fragment cityMinimalFields on cities {
    id
    name
    postcode
  }
`;
